import React from "react";
import ReactDOM from "react-dom/client";
import "./shared/styles/reset.css";
import "./shared/styles/index.css";
import App from "./App";
import reportWebVitals from "./shared/reportWebVitals";
import GoogleAnalytics from "./shared/GoogleAnalytics";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleAnalytics />
    <App />
  </React.StrictMode>
);

reportWebVitals();
